module.exports = __webpack_public_path__ + "static/media/book-logo.23f11220.svg";